import * as React from 'react'
import { FieldInputProps } from 'formik'

import TextInput from '../ui/textInput'

import './form.sass'
import { useTranslation } from 'react-i18next'

interface Props {
    label?: string
    error?: string
    placeholder?: string
    field: FieldInputProps<string>
    type: 'text' | 'email' | 'password' | 'number'
    errorDisplayBlock?: boolean
    autocomplete?: string
}

const TextField: React.FunctionComponent<Props> = ({
    field,
    label,
    placeholder,
    type,
    error,
    errorDisplayBlock = false,
    autocomplete = ''
}: Props) => {
    const [t] = useTranslation()
    return (
        <div className={error ? 'form__fieldContainer form__fieldContainer_error' : 'form__fieldContainer'}>
            <TextInput
                field={field}
                label={label}
                id={field.name}
                type={type}
                placeholder={placeholder}
                autocomplete={autocomplete}
            />
            <div className={errorDisplayBlock ? 'form__fieldErrorBlock' : 'form__fieldError'}>{error && t(error)}</div>
        </div>
    )
}

export default TextField
